import { createRootRoute } from '@tanstack/react-router';
import App from 'src/App';
import { Providers } from 'src/components/providers';
import { AuthProvider } from 'src/containers/contexts/auth-provider';
import { NotFound } from 'src/containers/not-found';

export const Route = createRootRoute({
  component: RouteComponent,
  notFoundComponent: NotFound,
});

function RouteComponent() {
  return (
    <AuthProvider>
      <Providers>
        <App />
      </Providers>
    </AuthProvider>
  );
}
